import React, { useContext } from "react";
import Search from "../adminPanel/appAndCategories/Search";
import { QueryContext } from "./contexts";
import "../adminPanel/appAndCategories/TopbarForApplication.scss";

const TopbarForCategory = () => {
  const { filterQuery } = useContext(QueryContext);
  return (
    <div className="topbar-for-application">
      <div className="topbar-container">
        <Search setQuery={filterQuery} testid="search-category" placeholder="Search for category" compact />
      </div>
    </div>
  );
};

export default TopbarForCategory;